import './text-image-teaser.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

class TextImageTeaser {
    constructor (element) {
        this.$textImageTeaser = element;
        this.orientation = this.$textImageTeaser.getAttribute('data-text-image-teaser-orientation');
        this.slider = null;
        this.$textImageTeaserItems = this.$textImageTeaser.querySelectorAll('[data-text-image-teaser="slide"]');
        this.$sliderContainer = this.$textImageTeaser.querySelector('[data-text-image-teaser="slider"]');
        this.$prevButton = this.$textImageTeaser.querySelector('.swiper-button-prev');
        this.$nextButton = this.$textImageTeaser.querySelector('.swiper-button-next');
        this.sliderActive = false;
        this.count = parseInt(this.$textImageTeaser.dataset.textImageTeaserCount);
    }

    initialize () {
        if (this.count > 1) {
            this.checkSizes();
        }
    }

    initSlider () {
        this.sliderActive = true;

        this.slider = new Swiper(this.$sliderContainer, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 1,
            speed: 500,
            autoHeight: false,
            pagination: {
                el: this.$textImageTeaser.querySelector('.swiper-pagination'),
                type: 'progressbar',
                clickable: false
            },
            keyboard: true,
            a11y: {
                prevSlideMessage: window.translations.slider.prevSlideMessage,
                nextSlideMessage: window.translations.slider.nextSlideMessage,
                firstSlideMessage: window.translations.slider.firstSlideMessage,
                lastSlideMessage: window.translations.slider.lastSlideMessage,
                slideLabelMessage: window.translations.slider.slideLabelMessage
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                1440: {
                    slidesPerView: 3
                }
            }
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.sliderActive = false;
        }
    }

    checkSizes () {
        const toggleSliderState = () => {
            let initSlider = false;

            if (window.mediaMatch[1440].matches) {
                initSlider = this.count > 3;
            } else if (window.mediaMatch[768].matches) {
                initSlider = this.count > 2;
            } else if (!window.mediaMatch[768].matches) {
                initSlider = this.count > 1;
            }

            if (initSlider && !this.sliderActive) {
                this.initSlider();
            }

            if (!initSlider && this.sliderActive) {
                this.destroySlider();
                this.sliderActive = false;
            }
        };

        toggleSliderState();

        [768, 1024, 1440].forEach(bp => {
            window.mediaMatch[bp].addEventListener('change', () => toggleSliderState());
        });
    }
}

export { TextImageTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $textImageTeasers = $context.querySelectorAll('[data-text-image-teaser="root"]');

        for (let i = 0; i < $textImageTeasers.length; i++) {
            const $textImageTeaser = new TextImageTeaser($textImageTeasers[i]);
            $textImageTeaser.initialize();
        }
    }
});
